export default __webpack_public_path__ + "static/media/wallet-black.513f4cdb.svg";